<div mat-dialog-content>
  <div class="body">
    <div class="close-icon">
      <img alt="" (click)="onClose()" src="../../../../../../assets/checkout-icons/x-black-icon.svg" />
    </div>
    <img src="../../../../../../assets/checkout-icons/error_icon.svg" alt="" />
    <div class="body__title">{{ msg }}</div>
  </div>
</div>
